import { render } from "./AgeCategoryForm.vue?vue&type=template&id=05bf592a&scoped=true"
import script from "./AgeCategoryForm.vue?vue&type=script&lang=js"
export * from "./AgeCategoryForm.vue?vue&type=script&lang=js"

import "./AgeCategoryForm.vue?vue&type=style&index=0&id=05bf592a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bf592a"]])

export default __exports__